export const ADD_STATUS = 'ADD_STATUS'
export const ADD_HOLIDAYS = 'ADD_HOLIDAYS'
export const ADD_USER_WORkDAYS = 'ADD_USER_WORkDAYS'
export const ADD_USER_PUBLIC_HOLIDAYS = 'ADD_USER_PUBLIC_HOLIDAYS'
export const ADD_MANAGE_HOLIDAYS = 'ADD_MANAGE_HOLIDAYS'
export const ADD_SOCIETY_MANAGE_HOLIDAYS = 'ADD_SOCIETY_MANAGE_HOLIDAYS'
export const LOAD_SOCIETY_OFFICES_HOLIDAYS = 'LOAD_SOCIETY_OFFICES_HOLIDAYS'
export const LOAD_USERS_HOLIDAYS = 'LOAD_USERS_HOLIDAYS'